<div class="select-day">
  @if (hasDays) {
    <div class="days">
      <div class="select-day__tip">
        <ion-label>Please select the preferred day of the month for your premium to be deducted</ion-label>
      </div>

      <ion-radio-group [value]="day">
        @for (o of days; track o.day) {
          <ion-radio [value]="o.day" (click)="day = o.day" labelPlacement="end">
            <b>{{ o.day | ordinalSuffix }}</b>
            <br/>
            Average Closing Balance: {{ o.averageBalance | pounds }}
          </ion-radio>
        }
      </ion-radio-group>

      <div class="select-day__buttons">
        <ion-button (click)="proceed()" [disabled]="!day">
          Continue
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  } @else {
    <div class="select-day__tip">
      <ion-label>I'm sorry, you don't appear to meet the affordibility criteria.</ion-label>
    </div>
    <div class="select-day__buttons">
      <ion-button (click)="proceed()" [disabled]="">
        Continue
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  }
</div>
